import useTranslation from 'next-translate/useTranslation';
import { memo } from 'react';

import { Box, CardVideoTutorial, Grid, Typography } from '@core/component';
import { Translate } from '@core/constant';
import { useContextMediaQuery } from '@core/context';
import { EActionAttribute, ETypographyVariant, PageSSR } from '@core/type';
import { TutorialVideosEntity } from '@core/type/api';

export type PageTutorialVideosProps = PageSSR<TutorialVideosEntity, unknown, unknown>;

const MOBILE_SPACE = 48;
const DESKTOP_SPACE = 64;

const ViewTutorialVideosContainer = ({ tutorialVideos }: PageTutorialVideosProps) => {
  const { isMobile } = useContextMediaQuery();

  const { t: tTutorialVideos } = useTranslation(Translate.page.TUTORIAL_VIDEOS);

  return (
    <Box marginTop={48}>
      <Box>
        <Typography as={EActionAttribute.H1} variant={ETypographyVariant.H2} marginBottom={16}>
          {tTutorialVideos('index.title')}
        </Typography>
      </Box>
      <Box marginBottom={64} maxWidth={750}>
        <Typography>{tTutorialVideos('index.subtitle')}</Typography>
      </Box>
      {tutorialVideos.length > 0 && (
        <Grid isContainer columnSpacing={30} rowSpacing={isMobile ? MOBILE_SPACE : DESKTOP_SPACE}>
          {tutorialVideos.map(
            ({ name, slug, image }) =>
              name && (
                <Grid key={name} sm={6} lg={4}>
                  <CardVideoTutorial slug={slug} title={name} imageProps={image} />
                </Grid>
              ),
          )}
        </Grid>
      )}
    </Box>
  );
};

export const ViewTutorialVideos = memo(ViewTutorialVideosContainer);
